// src/Components/BankingReconciliation/components/RequisitionRow.jsx
import React from "react";
import Styles from "../RequisitionTable/RequisitionTable.module.css";
import { formatInr, signed, STATUS_META } from "../../utils/reconFormat";

const subCaption = (row) => {
  switch (row.status) {
    case "BALANCE_LEFT": return `${formatInr(row.remaining)} MWh yet to be drawn`;
    case "DRAWAL_PENDING": return `${formatInr(row.remaining)} MWh to be drawn`;
    case "OVER_DRAWN": return `${formatInr(row.remaining)} MWh excess`;
    default: return "Fully reconciled";
  }
};

const RequisitionRow = ({ row, onSelect }) => {
  const meta = STATUS_META[row.status];
  const drawn = row.drawn || 0;
  const pct = row.drawable > 0 ? Math.min(100, Math.max(0, (drawn / row.drawable) * 100)) : 0;
  const fillPct = row.status === "OVER_DRAWN" ? 100 : pct;

  return (
    <div
      className={`${Styles.row} ${onSelect ? Styles.rowClickable : ""}`}
      onClick={() => onSelect?.(row)}
    >
      <div className={Styles.colContract}>{row.contractId || "—"}</div>
      <div className={Styles.colName}>
        <div className={Styles.name}>{row.name}</div>
        <div className={Styles.dates}>{row.injDates}{row.drawDates ? ` · ${row.drawDates}` : ""}</div>
      </div>
      <div className={Styles.colBf}>{row.bf}%</div>
      <div className={Styles.colNum}>{formatInr(row.injected)}</div>
      <div className={Styles.colNum}>
        {formatInr(row.drawable)}
        <div className={Styles.sublabel}>Inj × BF</div>
      </div>
      <div className={Styles.colNum}>{row.drawn == null ? "—" : formatInr(row.drawn)}</div>
      <div className={Styles.colRemaining}>
        <div className={Styles.remainingVal} style={{ color: meta.color }}>{signed(row.remaining)}</div>
        <div className={Styles.remainBar}>
          <div className={Styles.remainFill} style={{ width: `${fillPct}%`, background: meta.color }} />
        </div>
      </div>
      <div className={Styles.colStatus}>
        <span className={Styles.pill} style={{ color: meta.color, background: `${meta.color}1a` }}>
          <span className={Styles.pillDot} style={{ background: meta.color }} />
          {meta.label}
        </span>
        <div className={Styles.statusSub}>{subCaption(row)}</div>
      </div>
      {onSelect && <span className={Styles.rowChevron}>&#8250;</span>}
    </div>
  );
};

export default RequisitionRow;
